/**
 * Renders a row in the stats table for a player
 */
import React, { useState } from "react";
import { Link } from "react-router-dom";

const StatsRow = ({ rowContent, index, stats, nm }) => {
  const [isExpanded, setIsExpanded] = useState(false); // State to track if row is expanded

  const toggleExpand = () => {
    setIsExpanded(!isExpanded); // Toggle expanded state
  };

  const rowClass = index % 2 === 0 ? "bg-light-1 dark:bg-dark-1" : "bg-light-2 dark:bg-dark-4";

  stats.sort((a,b) => a.date < b.date);

  return (
    <>
      <tr
        onClick={toggleExpand}
        className={`cursor-pointer ${rowClass} hover:bg-light-3 dark:hover:bg-dark-6 ease-in-out duration-200`} // Hover effect TODO make transition
      >
        {rowContent}
      </tr>

      {isExpanded && (
        <>
          {stats.map((stat, index) => (
              (!nm || stat.gk_seconds > 0) ?
                <tr className="dark:bg-dark-1 bg-light-1 text-darken">
                  <td className="py-1 text-center max-xs:text-xs">
                    {new Date(stat.date * 1000).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    })}
                  </td>

                  <td className="py-1 text-center max-xs:text-xs items-center justify-center">
                    <Link
                      to={`/game/${stat.game_id}`}
                      className="flex items-start justify-center w-full xs: mx-auto xs:w-1/2 dark:hover:text-dark-5 hover:text-buiha-red ease-in-out duration-200"
                    >
                      <div className="flex items-start justify-start">
                        <p className="hidden xxs:block">
                          {stat.team_id === stat.home_id ? `vs` : `@`}
                        </p>
                        <img
                          src={`http://buiha.org.uk/assets/img/icon/md/${
                            stat.team_id === stat.home_id
                              ? stat.away_img
                                ? stat.away_img.toLowerCase().replace(" ","")
                                : "default"
                              : stat.home_img
                              ? stat.home_img.toLowerCase().replace(" ","")
                              : "default"
                          }.png`}
                          alt=""
                          className="team-logo xxs:w-6 xxs:h-6 w-5 h-5 flex mx-1"
                        />
                        {stat.team_id === stat.home_id
                          ? stat.away_name
                          : stat.home_name}
                      </div>
                    </Link>
                  </td>

                  <td className="py-1 text-center max-xs:text-xs">
                    {stat.result} {stat.home_score}-{stat.away_score}
                  </td>
                  <td className="py-1 text-center max-xs:text-xs">
                    {!nm ? stat.goals : Math.floor(stat.gk_seconds / 60)}
                  </td>
                  <td className="py-1 text-center max-xs:text-xs">
                    {!nm ? stat.assists : stat.gk_goals_against}
                  </td>
                  <td className="py-1 text-center max-xs:text-xs">
                    {!nm ? stat.goals + stat.assists : stat.gk_shots_against}
                  </td>
                  <td className="py-1 text-center max-xs:text-xs">
                    {!nm
                      ? stat.pim
                      : (stat.gk_shots_against > 0
                                ? (
                                    (stat.gk_shots_against - stat.gk_goals_against) /
                                    stat.gk_shots_against
                                ).toFixed(2)
                                : "-")
                    }
                  </td>
                  {nm && (
                    <td className="py-1 text-center max-xs:text-xs">
                      {/* Calculate GAA */}
                      {stat.gk_seconds > 0
                        ? (
                            (stat.gk_goals_against / (stat.gk_seconds / 60)) *
                            60
                          ).toFixed(2)
                        : "0.00"}
                    </td>
                  )}

                  {nm && (
                    <td className="py-1 text-center max-xs:text-xs">
                      {/* Shutout Logic */}
                      {stat.gk_goals_against > 0 ? "0" : "1"}
                    </td>
                  )}
                </tr> : null
          ))}
        </>
      )}
    </>
  );
};

export default StatsRow;
